import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import API from "../services/api";
import "./AvailableSurplus.css";

function NgoCollectFood() {
  const [surplusList, setSurplusList] = useState([]);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // ================= LOAD LOGGED-IN USER =================
  useEffect(() => {
    const userId = localStorage.getItem("userId");
    const role = localStorage.getItem("role");

    if (userId && role === "NGO") {
      setUser({ id: userId, role: role });
    } else {
      alert("Please login first");
      navigate("/ngo/login");
    }

    fetchAvailableSurplus();
  }, [navigate]);

  // ================= FETCH AVAILABLE SURPLUS =================
  const fetchAvailableSurplus = async () => {
    try {
      const response = await API.get("/surplus/available");
      setSurplusList(response.data);
    } catch (error) {
      console.error("Error fetching surplus:", error);
    }
  };

  // ================= COLLECT FOOD =================
  const collectFood = async (id) => {
    if (!user) {
      alert("User not logged in");
      return;
    }

    if (user.role !== "NGO") {
      alert("Only NGO can collect food");
      return;
    }

    try {
      const response = await API.put(`/surplus/collect/${id}?ngoId=${user.id}`);

      alert(response.data);

      // Refresh table after collect
      fetchAvailableSurplus();
    } catch (error) {
      alert(error.response?.data || "Error collecting food");
    }
  };

  return (
    <>
      {/* ================= HEADER ================= */}
      <header className="header">
        <div className="header-container">
          <h1 className="logo">SaveBite</h1>

          <nav className="navigation">
            <NavLink to="/ngo/dashboard" className="nav-link">
              Dashboard
            </NavLink>

            <NavLink to="/ngo/collectfood" className="nav-link active">
              Available Surplus
            </NavLink>

            <NavLink to="/ngo/collectedfood" className="nav-link">
              Collected Food
            </NavLink>

            <NavLink to="/ngo/account" className="nav-link">
              My Account
            </NavLink>
          </nav>
        </div>
      </header>

      {/* ================= PAGE CONTENT ================= */}
      <main className="collect-container">
        <h2 className="page-title">Available Surplus Food</h2>
        <p className="page-subtitle">
          Browse surplus food shared by hotels and collect it for distribution.
        </p>

        <div className="table-wrapper">
          <table className="surplus-table">
            <thead>
              <tr>
                <th>Hotel Name</th>
                <th>Food Title</th>
                <th>Description</th>
                <th>Quantity</th>
                <th>Location</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {surplusList.length === 0 ? (
                <tr>
                  <td colSpan="6" className="no-data">
                    No surplus food available
                  </td>
                </tr>
              ) : (
                surplusList.map((item) => (
                  <tr key={item.id}>
                    <td>{item.hotelName}</td>
                    <td>{item.title}</td>
                    <td>{item.description}</td>
                    <td>{item.quantity}</td>
                    <td>{item.location}</td>
                    <td>
                      <button
                        className="collect-btn"
                        onClick={() => collectFood(item.id)}
                      >
                        Collect
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </main>
    </>
  );
}

export default NgoCollectFood;
